import { render, staticRenderFns } from "./NewsDetailUser.vue?vue&type=template&id=274f6b9a"
import script from "./NewsDetailUser.vue?vue&type=script&lang=js"
export * from "./NewsDetailUser.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailUser.vue?vue&type=style&index=0&id=274f6b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports